import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type {
  BackendOAuthConsentRequest,
  BackendQueryOauthConsentRequestArgs,
} from 'src/types/backend';

const QUERY = gql`
  query OAuthConsentRequest($authorizeUrl: String!) {
    oauthConsentRequest(authorizeUrl: $authorizeUrl) {
      client {
        name
        host
        logoUri
        uri
      }
      redirectHost
      trusted
      selectedWorkspaceId
      stopReason
      workspaces {
        id
        name
        eligible
        ineligibleReason
        customer {
          id
          name
        }
      }
    }
  }
`;

type Variables = BackendQueryOauthConsentRequestArgs;
type Result = BackendOAuthConsentRequest;

export const queryOAuthConsentRequest = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);

  return getSingleProp<Result>(result.data);
};
